import React, { useEffect } from "react";
import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Group,
  HoverCard,
  Input,
  Loader,
  Popover,
  ScrollArea,
  Table,
  Text,
  Tooltip,
  createStyles,
} from "@mantine/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import TableLoader from "../TableLoader";
import NoteModalNew from "../NoteModal/NoteModalNew";
import { IconSearch, IconTrash } from "@tabler/icons-react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { changeTaskStatus, deleteTask } from "../../services/task";
import { decrypt } from "../../utils";
import MenuDropdown from "../NoteTableRow/MenuDropdown";
import useDebounce from "../../utils/useDebounce";
import { getTodaysTasks } from "../../services/dashboard";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    "& th": {
      backgroundColor: "#fff",
      color: "#000 !important",
    },

    transition: "box-shadow 150ms ease",
  },

  bg1: {
    "& td": {
      background: "#fff",
    },
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
  },
  notFoundTextContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "460px",
  },
  searchInput: {
    width: "32%",
    marginBlock: "10px",
    borderRadius: "10px",
    "& :focus-within": {
      border: "1px solid #D0D5DD",
    },
    "& :focus": {
      border: "1px solid #D0D5DD",
    },
    "& :hover": {
      border: "1px solid #D0D5DD",
    },
    "& :active": {
      border: "1px solid #D0D5DD",
    },
    "& :focus-visible": {
      border: "1px solid #D0D5DD",
    },
  },
}));

export function TaskDashTable({ startDate, endDate }) {
  const { tasks, loading } = useSelector((state) => state?.dashboard);
  const { classes, cx } = useStyles();
  const [scrolled, setScrolled] = useState(false);
  const [isopen, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [noteType, setNoteType] = useState(null);
  const [view, setView] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebounce(searchTerm, 2000);
  const navigate = useNavigate();

  useEffect(() => {
    if (debouncedSearch) {
      getTodaysTasks(debouncedSearch, startDate, endDate);
    } else {
      getTodaysTasks("", startDate, endDate);
    }
  }, [debouncedSearch]);

  const { profile } = useSelector((state) => state.profile);

  return (
    <ScrollArea
      h={460}
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
    >
      <NoteModalNew
        opened={isopen}
        close={() => {
          setOpen(false);
          setData(null);
        }}
        noteType={noteType}
        title={"Add New Note"}
        view={view}
        setView={setView}
        data={data}
      />
      {/* <NoteDrawer
        title="Note"
        opened={isopen}
        close={() => {
          setOpen(false);
          setData(null);
        }}
        noteType={noteType}
        // title={"Add New Note"}
        view={view}
        setView={setView}
        data={data}
      /> */}

      <div style={{ overflowX: "auto" }}>
        <div style={{ minWidth: "600px" }}>
          {tasks?.length > 0 && (
            <Input
              icon={<IconSearch />}
              placeholder="Search"
              className={classes.searchInput}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          )}
          {loading ? (
            <Flex align="center" justify="center" h={460}>
              <Loader color="#FFBA45" />
            </Flex>
          ) : tasks?.length > 0 ? (
            <Table
              withBorder
              fontSize={"sm"}
              verticalSpacing={"md"}
              sx={{ fontFamily: "Inter" }}
            >
              <thead
                className={cx(classes.header, { [classes.scrolled]: scrolled })}
              >
                <tr>
                  <th style={{ minWidth: "200px" }}>Task Type</th>
                  <th style={{ minWidth: "200px" }}>Staff Name</th>
                  {/* <th style={{ minWidth: "140px" }}>Shift</th> */}
                  <th style={{ minWidth: "140px" }}>Client Name</th>
                  <th style={{ minWidth: "140px" }}>Facility Name</th>
                  <th style={{ minWidth: "140px" }}>Date</th>
                  <th style={{ minWidth: "120px" }}>Time</th>
                  <th style={{ minWidth: "180px" }}>Fields Done</th>
                  <th style={{ minWidth: "140px" }}>Task Completed</th>
                  {/* <th style={{ minWidth: "140px" }}>Notes</th> */}
                  <th style={{ minWidth: "140px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {tasks?.map((row, i) =>
                  row?.shift?.length > 0 ? (
                    row?.shift?.map((item) => (
                      <tr
                        style={{ cursor: "pointer" }}
                        className={i % 2 === 0 ? classes.bg2 : classes.bg1}
                        key={i}
                      >
                        {/* <td className={classes.border}>{row?.name}</td> */}
                        <td
                          className={classes.border}
                          onClick={() => {
                            navigate("/home/view-task", {
                              state: { ...row, selectedShift: item },
                            });
                          }}
                        >
                          {row?.taskType?.name}
                        </td>
                        <td
                          onClick={() => {
                            navigate("/home/view-task", {
                              state: { ...row, selectedShift: item },
                            });
                          }}
                        >
                          {item?.staff?.name}
                        </td>
                        <td
                          onClick={() => {
                            navigate("/home/view-task", {
                              state: { ...row, selectedShift: item },
                            });
                          }}
                          className={classes.border}
                        >
                          {decrypt(row?.client?.name, false) ||
                            row?.client?.name}
                        </td>
                        <td
                          onClick={() => {
                            navigate("/home/view-task", {
                              state: { ...row, selectedShift: item },
                            });
                          }}
                          className={classes.border}
                        >
                          {row?.facility?.name}
                        </td>
                        {/* <td>{item?.name}</td> */}
                        <td
                          onClick={() => {
                            navigate("/home/view-task", {
                              state: { ...row, selectedShift: item },
                            });
                          }}
                          className={classes.border}
                        >
                          {moment(row?.dateTime).format("MM/DD/YYYY")}
                        </td>
                        <td
                          onClick={() => {
                            navigate("/home/view-task", {
                              state: { ...row, selectedShift: item },
                            });
                          }}
                          className={classes.border}
                        >
                          {moment(row?.dateTime).format("hh:mm a")}
                        </td>
                        <td
                          onClick={() => {
                            navigate("/home/view-task", {
                              state: { ...row, selectedShift: item },
                            });
                          }}
                          className={classes.border}
                        >
                          <HoverCard
                            withArrow
                            shadow="md"
                            width={"100%"}
                            position="top"
                          >
                            <HoverCard.Target>
                              <span>
                                {row?.fieldsDone
                                  ?.filter(
                                    (fieldItem) =>
                                      fieldItem?.staff?.id ===
                                        item?.staff?.id &&
                                      fieldItem?.shift === item?.name
                                  )
                                  ?.map((field) => field?.field?.name)
                                  ?.slice(0, 3) // Show only the first 3 items
                                  ?.join(", ")}
                                {row?.fieldsDone?.filter(
                                  (fieldItem) =>
                                    fieldItem?.staff?.id === item?.staff?.id &&
                                    fieldItem?.shift === item?.name
                                ).length > 3
                                  ? "..." // Indicate there are more items
                                  : ""}
                              </span>
                            </HoverCard.Target>
                            {row?.fieldsDone?.filter(
                              (fieldItem) =>
                                fieldItem?.staff?.id === item?.staff?.id &&
                                fieldItem?.shift === item?.name
                            )?.length > 3 && (
                              <HoverCard.Dropdown>
                                <Text size="sm">
                                  {row?.fieldsDone
                                    ?.filter(
                                      (fieldItem) =>
                                        fieldItem?.staff?.id ===
                                          item?.staff?.id &&
                                        fieldItem?.shift === item?.name
                                    )
                                    ?.map((field) => field?.field?.name)
                                    ?.slice(3) // Take all items after the third
                                    ?.join(", ") || "No additional fields"}
                                </Text>
                              </HoverCard.Dropdown>
                            )}
                          </HoverCard>
                        </td>
                        {/* <td className={classes.border}>
                            {row?.fieldsDone
                              ?.filter(
                                (fieldItem) =>
                                  fieldItem?.staff?.id === item?.staff?.id &&
                                  fieldItem?.shift === item?.name
                              )
                              ?.map((field) => field?.field?.name)
                              ?.join(", ")}
                          </td> */}
                        <td
                          onClick={() => {
                            navigate("/home/view-task", {
                              state: { ...row, selectedShift: item },
                            });
                          }}
                          className={classes.border}
                        >
                          {/* {moment
                          .duration(moment(row?.taskEndAt).diff(moment()))
                          .asSeconds() <= 0
                          ? "Completed"
                          : "Draft"} */}
                          {row?.status === "completed"
                            ? "Completed"
                            : moment
                                .tz(
                                  moment(row?.taskEndAt),
                                  profile?.user?.timeZone
                                )
                                .diff(
                                  moment.tz(moment(), profile?.user?.timeZone)
                                ) <= 0
                            ? "Completed"
                            : "Draft"}
                          {/* {row?.status?.toLowerCase() === 'draft' ? 'Draft' : 'Completed'} */}
                        </td>
                        {/* <td className={classes.border}>
                        {row?.notes?.find(
                          (obj) =>
                            obj?.staff?.id === item?.staff?.id &&
                            obj.shift === item.name
                        )?.note || "-"}
                      </td> */}
                        <td>
                          <MenuDropdown
                            row={row}
                            taskItem={item}
                            isTask={true}
                            isDashboradMode={true}
                            startDate={startDate}
                            endDate={endDate}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr style={{ cursor: "pointer" }} key={i}>
                      {/* <td className={classes.border}>{row?.name}</td> */}
                      <td className={classes.border}>{row?.taskType?.name}</td>
                      <td>{row?.startedBy?.name}</td>
                      <td className={classes.border}>
                        {decrypt(row?.client?.name, false) || row?.client?.name}
                      </td>
                      <td className={classes.border}>{row?.facility?.name}</td>
                      <td className={classes.border}>
                        {moment(row?.dateTime).format("MM/DD/YYYY")}
                      </td>
                      <td className={classes.border}>
                        {moment(row?.dateTime).format("hh:mm a")}
                      </td>
                      <td className={classes.border}>
                        {row?.fieldsDone
                          ?.filter(
                            (fieldItem) =>
                              fieldItem?.staff?.id ===
                                row?.startedBy?.staff?.id &&
                              fieldItem?.shift === row?.startedBy?.name
                          )
                          ?.map((field) => field?.field?.name)
                          ?.join(", ")}
                        {/* <span>{field?.field?.name}, </span> */}
                      </td>
                      <td className={classes.border}>{row?.status}</td>
                      <td className={classes.border}>
                        <MenuDropdown
                          row={row}
                          isTask={true}
                          taskItem={row?.startedBy}
                          isDashboradMode={true}
                        />
                      </td>
                    </tr>
                  )
                )}
                {/* {tasks?.map((row, i) => (
                  <NoteTableRowDashboard
                    row={row}
                    key={i}
                    index={i}
                    open={(data) => {
                      setData(data);
                      setOpen(true);
                    }}
                    setView={() => {
                      setView(true);
                    }}
                  />
                ))} */}
              </tbody>
            </Table>
          ) : (
            <div className={classes.notFoundTextContainer}>
              <p className={classes.notFoundText}>
                You don&apos;t have any record for Tasks in last 24 hours
              </p>
            </div>
          )}
        </div>
      </div>
    </ScrollArea>
  );
}
